/* eslint-disable no-undef */
import { call, put, takeEvery, takeLatest } from "redux-saga/effects"

// Login Redux States
import { ADD_GROUP } from "./actionTypes"
import { apiError, addGroupSuccess } from "./actions"

//Include Both Helper File with needed methods
import { addGroup } from "../../../helpers/backend_helper"

function* add(action) {
  try {
    const response = yield call(addGroup, action.payload.form)
    if (response == undefined) throw new Error("API error")
    if (!response.success) throw new Error("Error al guardar al usuario")
    yield put(addGroupSuccess(response))
  } catch (error) {
    console.log(error.message)
    yield put(apiError(error.message))
  }
}

function* groupAddSaga() {
  yield takeEvery(ADD_GROUP, add)
}

export default groupAddSaga
